import { memo } from 'react';
import { useTranslation } from 'react-i18next';

import { Typography } from 'antd';

import { useGetPatternWatchlistsQuery } from '../../api/pattern-watchlist.api';
import { useSelectedPatternWatchlistId } from '../../model/selectors/pattern-watchlist-selected';

interface CurrentPatternWatchlistProps {
    className?: string;
}

export const CurrentPatternWatchlist = memo(
    (props: CurrentPatternWatchlistProps) => {
        const { className } = props;

        const { t } = useTranslation('pattern-watchlist');
        const selectedPatternWatchlistId = useSelectedPatternWatchlistId();
        const {
            data: watchlists = [],
            isLoading,
            error,
        } = useGetPatternWatchlistsQuery();

        if (isLoading) {
            return null;
        }

        if (error) {
            return null;
        }

        const selectedWatchlist = watchlists.find(
            (watchlist) => watchlist.id === selectedPatternWatchlistId,
        );

        if (!selectedWatchlist) {
            return null;
        }

        return (
            <div className={className}>
                <Typography.Text>
                    {t('currentWatchlist')}{' '}
                    <Typography.Text strong>
                        {selectedWatchlist.name}
                    </Typography.Text>
                </Typography.Text>
            </div>
        );
    },
);

CurrentPatternWatchlist.displayName = 'CurrentPatternWatchlist';
